<template>
  <div class="container">
    <div class="bgcF">
      <div class="content">
        <div class="top">
          <div class="title">协同报送</div>
          <div class="linkage-right">
            <input
              type="text"
              placeholder="请输入"
              v-model="searchValue"
              class="no-outline-input" />
            <div class="button" @click="formSampleList()">
              <img src="../../assets/images/search.png" alt="" />
            </div>
            <div class="resetBtn" @click="reset()">重置</div>
          </div>
        </div>
        <div class="xian"></div>
        <ul class="custom-list" v-if="tab == 1">
          <li v-for="(item, index) in submitTableList" :key="index">
            <div class="li-content">
              <div style="display: flex">
                <div class="custom-link hover-underline" @click="goInfo(item)">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div class="tableBox" v-if="tab == 2">
          <button @click="tab = 1" style="width: 80px; height: 30px;background-color: #fff;margin:10px 0;border:1px solid #ccc;">
            返回列表
          </button>
          <el-table
            :data="allOrgData"
            style="width: 100%;"
            max-height="800"
            :summary-method="getSummaries"
            show-summary
            :header-cell-style="{ 'text-align': 'center' }"
            :cell-style="{ 'text-align': 'center' }">
            <el-table-column
              prop="deptName"
              fixed
              width="220"
              show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.deptName || "" }}
              </template>
            </el-table-column>

            <el-table-column
              :label="item.title"
              prop="reportData"
              show-overflow-tooltip
              v-for="(item, index) in tableDataShow"
              :key="index">
              <template v-if="item.childrenheadList.length">
                //添加一列，让这一列放到表格最后面去
                <!-- width="120" -->
                <el-table-column
                  prop="reportData"
                  :label="lv2.childrenTitle"
                  show-overflow-tooltip
                  v-for="(lv2, lv2Index) in item.childrenheadList"
                  :key="lv2Index">
                  <template slot-scope="scope">
                    {{
                      scope.row.reportData[index].childrenheadList[lv2Index]
                        .valueText
                    }}
                  </template>
                </el-table-column>
              </template>

              <template v-else>
                <!-- width="120" -->
                <el-table-column prop="reportData" :label="item.title">
                  <template slot-scope="scope">
                    {{ scope.row.reportData[index].valueText }}
                  </template>
                </el-table-column>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="bottom-info">
        <div class="bottom-box">
          <div>Copyright © 池州消防支队 allright reserved</div>
          <div>【后台管理】</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { formSampleList } from "@/api/index";
import { deepClone } from "@/utils/ruoyi";

export default {
  data() {
    return {
      submitTableList: [],
      selectedItem: "支队领导",
      leaderList: [],
      text: "",
      map: null,
      team: "",
      serachFrom: {
        pageNum: 1,
        pageSize: 999,
      },
      oragenFrom: {},
      maker: null,
      teamList: [],
      searchValue: "",
      tab: 1,
      tableDetail: {},
      tableDataShow: {},
      allOrgData: {},
    };
  },
  mounted() {
    this.formSampleList();
  },
  created() {},
  methods: {
    formSampleList() {
      formSampleList({
        ...this.serachFrom,
        name: this.searchValue,
      }).then((res) => {
        let arr = res.data.data.list.filter((item) => item.contents);
        this.submitTableList = arr;
        this.tab = 1;
      });
    },
    returnshow() {
      this.$emit("setCilck");
    },
    search() {
      this.formSampleList();
    },
    reset() {
      this.searchValue = "";
      this.formSampleList();
    },
    goInfo(info) {
      this.tab = 2;
      this.tableDetail = info; //表格详情
      // ??表格结构tableDataShow
      this.tableDataShow = JSON.parse(info.content); //表格详情
      // 编辑过回显 机构会更新暂未匹配
      if (info.contents) {
        let arr = JSON.parse(info.contents);
        this.allOrgData = deepClone(arr);
      }
    },
    // 表格总计
    getSummaries(param) {
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总计";
          return;
        }
        // 各机构对应reportData
        const values = data.map((item) => item[column.property]);
        // console.log(values, "VVVVVVVVV");!!!!!
        // 只拿到childrenheadList的第一个的合集
        // 两种计算情况
        const groupedData = values.reduce((acc, curr) => {
          curr.forEach((item, i) => {
            if (item.childrenheadList && item.childrenheadList.length) {
              item.childrenheadList.forEach((items) => {
                const title = items.childrenTitle;
                if (!acc[title]) {
                  acc[title] = [];
                }
                acc[title].push({
                  name: title,
                  value: Number(items.valueText) || 0,
                  index: i,
                });
              });
            } else {
              const title = item.title;
              if (!acc[title]) {
                acc[title] = [];
              }
              acc[title].push({
                name: title,
                value: Number(item.valueText) || 0,
                index: i,
              });
            }
          });
          return acc;
        }, {});
        const result = Object.values(groupedData);

        sums[index] = result[index - 1].reduce((acc, curr) => {
          return acc + curr.value;
        }, 0);
      });

      return sums;
    },
  },
};
</script>

<style scoped lang="scss">
#map {
  width: 100%;
  height: 398px;
}
.container {
  width: 100%;
  background: #f0f5ff;
  display: flex;
  justify-content: center;
}
.bgcF {
  width: 1120px;
  background-color: #fff;
}
.dispF {
  display: flex;
  margin-bottom: 16px;

  .lingdao {
    width: 64px;
    height: 35px;
    line-height: 35px;
    font-weight: bold;
    font-size: 16px;
    color: #333333;
  }
}
.nav-tab {
  width: 1120;
  height: 48px;
  background: #f5f5f5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;

  .ims {
    width: 23px;
    height: 20px;
    margin-left: 40px;
  }
  .imgs {
    width: 16px;
    margin: 0;
    height: 14px;
    vertical-align: middle;
    margin-right: 8px;
  }
  div {
    font-size: 16px;
    color: #2b56ac;
    margin-left: 16px;
  }
}

.content {
  width: 1040px;
  margin: 0;
  padding: 40px;

  .top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    .title {
      font-weight: bold;
      font-size: 16px;
      color: #2b56ac;
    }
  }
  .xian {
    margin-top: 10px;
    width: 1040px;
    height: 1px;
    background-color: #ebebeb;
  }
}

.bottom-info {
  width: 1120px;
  height: 100px;
  background: #0e67ab;
  color: #fff;
  font-size: 14px;
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  .bottom-box div {
    margin: 6px 0;
    text-align: center;
  }
}
.linkage-right {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 136px;
  input {
    width: 110px;
    height: 24px;
    border-radius: 4px 0px 0px 4px;
    border: 1px solid #2b56ac;
  }
  .linkage-right2 {
    width: 136px;
  }
  .no-outline-input {
    outline: none;
  }

  .no-outline-input:focus {
    border-color: #2b56ac;
  }

  .button {
    min-width: 24px;
    height: 28px;
    background: #2b56ac;
    border-radius: 0px 4px 4px 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 11px;
      height: 12px;
    }
  }
}
.custom-list {
  list-style-type: none;
  padding: 0 12px;
  display: flex; /* 使用 Flexbox */
  flex-wrap: wrap; /* 允许换行 */
}

.custom-list li {
  width: calc(50% - 20px); /* 每个 li 宽度为 50% 减去间距 */
  position: relative;
  padding-left: 18px;
  margin: 10px 0;
}

.custom-list li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 4px;
  background-color: #c1c5cd;
  border-radius: 50%;
}

.li-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;

  span {
    display: inline-block;
    width: 40px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    background: #ffdfdf;
    border-radius: 4px;
    font-size: 10px;
    color: #cc0000;
    // margin-left: 10px;
  }
}
.hover-underline {
  cursor: pointer; /* 鼠标悬停时显示手形光标 */
}

.hover-underline:hover {
  text-decoration: underline; /* 悬停时添加下划线 */
}
.tableBox {
  max-width: 1040px;
}
::v-deep.el-table {
  .cell {
    text-align: center !important;
  }
}
::v-deep.el-table__cell {
  text-align: center !important;
}
::v-deep.cell {
  text-align: center !important;
}
.resetBtn {
  font-size: 14px;
  cursor: pointer;
  width: 48px;
  height: 28px;
  background: #2b56ac;
  border-radius: 4px 4px 4px 4px;
  margin-left: 12px;
  text-align: center;
  line-height: 28px;
  color: #fff;
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
}

/* ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  display: none;
}
 
::v-deep .el-table__body-wrapper {
  -ms-overflow-style: none;  
  scrollbar-width: none; 
}

::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  display: none; 
}
 
::v-deep .el-table__body-wrapper {
  -ms-overflow-style: none;  
  scrollbar-width: none;  
}
::v-deep .gutter {
  width: 0 !important;
}  */
  /* .el-table--border::after, .el-table--group::after {
    top: 0;
    right: 0;
    width: 16px;
    height: 100%;
    background: white;
    color: white;

} */
 /* ::v-deep .el-table {
  .el-table__body-wrapper {
    &::-webkit-scrollbar {
      // 整个滚动条
      width: 0; // 纵向滚动条的宽度
      background: rgba(213, 215, 220, 0.3);
      border: none;
    }
 
    &::-webkit-scrollbar-track {

      border: none;
    }
  }
 
  th.gutter {
    display: none !important;
    width: 0 !important
  }
 
  colgroup col[name='gutter'] {
    display: none;
    width: 0;
  }
 
  .el-table__body {
    width: 100% !important;
  }
} */
</style>
